module.exports = __webpack_public_path__ + "img/23.1a013e9c.png";